// Public brand facts, shared by the SEO renderer and the client. Nothing secret lives here.

export const SITE = {
  name: "AI Class",
  shortName: "AI Class",
  locale: "id_ID",
  language: "id",
  author: "Aji Prakoso",
  logoPath: "/logo.png",
  ogImagePath: "/og-image.png",
  themeColor: "#050506",
  gaMeasurementId: "G-Q2RYM5X3CL",
} as const;

export const SITE_CONTACT = {
  contactFormUrl: "https://n8n.srv1191873.hstgr.cloud/form/jipraks-classroom-contact",
} as const;

export const SITE_SOCIALS = [
  { name: "YouTube", url: "https://www.youtube.com/@jipraks" },
  { name: "Instagram", url: "https://www.instagram.com/jipraks" },
  { name: "X", url: "https://x.com/jipraks" },
  { name: "Website", url: "https://jipraks.com" },
] as const;
